import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type QueryType = {
  rut: string;
  razonSocial: string;
  nombreFantasia: string;
  natFiscal: string;
  calle: string;
  calleNumero: string;
  departamento: string;
  ciudad: string;
  apto: string;
  email: string;
};

interface ApiResponse<T> {
  value: T;
}
interface RutResponse {
  m_Item1: string | boolean;
  m_Item2: string;
}

export const registerCustomer = async (
  query: QueryType
): Promise<RutResponse> => {
  const { rut, ...restQuery } = query;

  try {
    const res = await apiClient.post<ApiResponse<RutResponse>>(
      Endpoints.RegisterCustomer,
      { ...restQuery, documento: rut }
    );
    return res.data.value || '';
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
